function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.273 13.743L2.217 5.48c-.5-.584-.08-1.48.693-1.48h18.178c.774 0 1.194.896.694 1.481l-7.056 8.262v7.356c0 .669-.711 1.104-1.316.805l-3.635-1.8a.9.9 0 01-.503-.805v-5.556zM19.13 5.8H4.87l6.006 7.032a.895.895 0 01.215.581v5.33l1.818.9v-6.23c0-.212.076-.418.215-.58L19.13 5.8z"
});

var SvgFilter = function SvgFilter(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/filter.f69ec230.svg";
export { SvgFilter as ReactComponent };